import { useShiftModalDataContext } from 'modals/ShiftModal/ShiftModalProvider.data.context';
import { useSendToAgenciesFormContext } from 'modals/ShiftModal/src/views/SendToAgenciesView/SendToAgencies.form.context';
import { useGQLQuery } from 'hooks';
import { UseGQLQuery } from 'hooks/useGQLQuery/useGQLQuery.types';
import { FC, useContext, useEffect } from 'react';
import {
  SendToAgenciesSummaryViewQuery,
  SendToAgenciesSummaryViewQueryVariables,
} from 'types/graphql';
import { createGQLDataContext } from 'utils/createDataContext';
import { fetchJaneByIdQueryConfig } from '../SendToAgenciesSummaryView.constants';

export type FetchJaneByIdData = SendToAgenciesSummaryViewQuery & {
  janeEstimatedPayout: string;
};

export const FetchJaneByIdDataContext = createGQLDataContext({});

export const FetchJaneByIdDataProvider: FC = ({ children }) => {
  const { values } = useSendToAgenciesFormContext();

  const { data: shiftModalData } = useShiftModalDataContext();
  const order = shiftModalData?.order;

  const janeInfo = useGQLQuery<
    SendToAgenciesSummaryViewQuery,
    Nullable<FetchJaneByIdData>,
    SendToAgenciesSummaryViewQueryVariables
  >(
    fetchJaneByIdQueryConfig(
      values.jane_id,
      values.marketplace_jane_id,
      order?.position?.displayId,
      order?.community?.id,
    ),
  );

  useEffect(() => {
    janeInfo.fetch();
  }, []); // eslint-disable-line

  return (
    <FetchJaneByIdDataContext.Provider value={janeInfo}>
      {children}
    </FetchJaneByIdDataContext.Provider>
  );
};

export const useFetchJaneByIdDataContext = (): UseGQLQuery<FetchJaneByIdData> =>
  useContext(FetchJaneByIdDataContext);
